// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file accounts/my_profile_cover.proto (package protos.accounts, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { ProfileCoverType } from "./profile_cover_type_pb";
import { file_accounts_profile_cover_type } from "./profile_cover_type_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file accounts/my_profile_cover.proto.
 */
export const file_accounts_my_profile_cover: GenFile = /*@__PURE__*/
  fileDesc("Ch9hY2NvdW50cy9teV9wcm9maWxlX2NvdmVyLnByb3RvEg9wcm90b3MuYWNjb3VudHMiVgoOTXlQcm9maWxlQ292ZXISOwoLY292ZXJfaW1hZ2UYASABKAsyJC5wcm90b3MuYWNjb3VudHMuTXlQcm9maWxlQ292ZXJJbWFnZUgAQgcKBWNvdmVyIrwBChNNeVByb2ZpbGVDb3ZlckltYWdlEhEKCWltYWdlX3VybBgBIAEoCRIUCgxzb3VyY2Vfd2lkdGgYAiABKAUSFQoNc291cmNlX2hlaWdodBgDIAEoBRI1Cgpjb3Zlcl90eXBlGAQgASgOMiEucHJvdG9zLmFjY291bnRzLlByb2ZpbGVDb3ZlclR5cGUSLgoKY3JlYXRlZF9hdBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBiBnByb3RvMw", [file_google_protobuf_timestamp, file_accounts_profile_cover_type]);

/**
 * @generated from message protos.accounts.MyProfileCover
 */
export type MyProfileCover = Message<"protos.accounts.MyProfileCover"> & {
  /**
   * @generated from oneof protos.accounts.MyProfileCover.cover
   */
  cover: {
    /**
     * @generated from field: protos.accounts.MyProfileCoverImage cover_image = 1;
     */
    value: MyProfileCoverImage;
    case: "coverImage";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message protos.accounts.MyProfileCover.
 * Use `create(MyProfileCoverSchema)` to create a new message.
 */
export const MyProfileCoverSchema: GenMessage<MyProfileCover> = /*@__PURE__*/
  messageDesc(file_accounts_my_profile_cover, 0);

/**
 * @generated from message protos.accounts.MyProfileCoverImage
 */
export type MyProfileCoverImage = Message<"protos.accounts.MyProfileCoverImage"> & {
  /**
   * @generated from field: string image_url = 1;
   */
  imageUrl: string;

  /**
   * @generated from field: int32 source_width = 2;
   */
  sourceWidth: number;

  /**
   * @generated from field: int32 source_height = 3;
   */
  sourceHeight: number;

  /**
   * @generated from field: protos.accounts.ProfileCoverType cover_type = 4;
   */
  coverType: ProfileCoverType;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.accounts.MyProfileCoverImage.
 * Use `create(MyProfileCoverImageSchema)` to create a new message.
 */
export const MyProfileCoverImageSchema: GenMessage<MyProfileCoverImage> = /*@__PURE__*/
  messageDesc(file_accounts_my_profile_cover, 1);

